import {
    addClassBySelector,
    getAllBySelector,
    getBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {initLayerMenuGroupItemClicks} from "@/helpers/layer-menu-helper";
import {clearInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {clearGeoJsonLayers} from "@/helpers/ol/ol-geo-json-helper";
import {updateBookmarkPresentationByID} from "@/helpers/ol/ol-layer-helper";
import {clearBuffer} from "@/helpers/measure/measure-buffer-helper";
import {loadMutationSelectOptions} from "@/helpers/tools/tools-mutation-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {closeInfoMenu} from "@/helpers/layer/info/layer-info-helper.js";

window.layersActive = []

export function addLayerActiveById(id) {

    const numId = Number(id);
    if (Number.isInteger(numId) && !window.layersActive.includes(numId)) {
        window.layersActive.unshift(numId);
    } else if (typeof id === 'string' && !window.layersActive.includes(id)) {
        window.layersActive.unshift(id);
    }
}

export function addLayerActive(id, label, checked, type = 'layer', icon = 'fa fa-layer-group') {

    // removeLayerActive(id)

    if(checked) {
        addLayerActiveById(id)
    }

    let selector = 'layer-active'
    if(type === 'temporary') {
        selector = 'layer-active-temporary'
        showElementsBySelector('#div-layer-active-temporary')
    }


    // Don't add merged items
    const branchItem = getBranchItemByBookmarkPresentationID(id)

    if(branchItem.Merged === undefined) {

        document.getElementById(selector).insertAdjacentHTML(
            "beforeend",
            '<layer-menu-active-item data-checked="' + checked + '" data-type="' + type + '" data-id="' + id + '" data-label="' + label + '" data-icon="' + icon + '"></layer-menu-active-item>'
        )
    }

    getBySelector('#spnCountMyLayers').innerHTML = getAllBySelector('layer-menu-active-item').length
}

export function removeLayerActive(id) {

    const index = window.layersActive.indexOf(parseInt(id));
    if (index !== -1) {
        window.layersActive.splice(index, 1);
    }

    updateBookmarkPresentationByID(id, 'Visible', false)
    removeLayerActiveElement(id)

    clearBuffer()

    removeClassBySelector('layer-menu-group-item[data-id="' + id + '"] .btn-mutation', 'active')
}

export function removeLayerActiveElement(id) {
    let element = document.querySelector('layer-menu-active-item[data-id="' + id + '"]')
    if(element) {
        element.remove()
    }

    element = document.querySelector('layer-info-info-item-header[data-bookmark-presentation-name="' + id + '"]')
    // console.log(element)
    if(element) {
        element.remove()
        element = document.querySelector('layer-info-info-item-header')
        if(element) {
            element.click()
        } else {
            clearInfo()
            closeInfoMenu()
        }
    } else {
        clearInfo()
        closeInfoMenu()
    }
}

/**
 * Checks if there is an active layer
 * Ivo
 *
 * @returns {boolean}
 */
export function isThereAnActiveLayer() {
    return Array.isArray(window.layersActive) && window.layersActive.length > 0;
}
